import { AfterViewChecked, Component, HostListener, inject } from '@angular/core';
import { GodModeService } from '@jump-tools-front/shared';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'learniz-root',
  template: `
    <router-outlet></router-outlet>
  `,
  imports: [RouterOutlet],
})
export class AppComponent implements AfterViewChecked {
  private _godModeService = inject(GodModeService);
  mobileVh = 0;

  ngAfterViewChecked(): void {
    if (this.mobileVh !== window.innerHeight * 0.01) {
      this.mobileVh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${this.mobileVh}px`);
    }
  }

  @HostListener('window:resize', ['$event'])
  changeMobileVh(): void {
    this.mobileVh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${this.mobileVh}px`);
  }

  @HostListener('window:keydown', ['$event'])
  godMode($event: KeyboardEvent): void {
    this._godModeService.activeGodMode($event);
  }
}
